import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FeedbackModel } from 'common/models/page-models/feedback/feedback-data-model';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { FeedbackFormWidgetService } from 'common/widget/feedback/feedback-form-widget';

@Injectable({
    providedIn: 'root',
})
export class FeedbackFormResolver extends FormResolverService<FeedbackModel> {
    constructor(
        protected fs: FeedbackFormWidgetService,
        protected override  router: Router,
        protected override  systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

    //  modifyResponseData(dataModel: any, meta: any, widget: any) {
    //     dataModel.categories = dataModel.category;
    //     if (dataModel.id !== 0) {
    //         dataModel.questions = [...dataModel.questions];
    //     } else {
    //         dataModel.questions = [{ options: [] }, ...dataModel.questions];
    //     }
    //     return dataModel;
    // }
}
